import { MapCoordinates } from '../../../class/map-coordinates';
import { ISelectable } from 'app/global/component/react/react-map-demo/bd-sidebar/bd-select-area/selectable';

export class SearchSelectedItem {
    constructor(public item: ISelectable[], public coordinates: MapCoordinates) {
    }
}
